import ReactModal from 'react-modal'

import styles from './Modal.module.scss'
import CloseIcon from './close.svg'

export const ModalHeader = ({ children, onClose }) => {
  return (
    <div className={styles.Header}>
      <div className={styles.HeaderContent}>{children}</div>
      <div className={styles.Close} onClick={onClose}>
        <CloseIcon height='18' width='18' />
      </div>
    </div>
  )
}

export const ModalBody = ({ children }) => {
  return <div className={styles.ModalBody}>{children}</div>
}

const Modal = (props) => {
  return <ReactModal {...props} />
}

export default Modal
